import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import api from "./constants/api";
import io from "socket.io-client";
import { setMomentTime } from "@/util";
import moment from "moment";
import { Client } from "@twilio/conversations";
import firebase from "firebase/app";
import "firebase/messaging";
import { normalizeLocale, applyLocaleSettings } from "@/i18n";

Vue.use(Vuex);

function parseStoredJson(key, fallback) {
    const rawValue = localStorage.getItem(key);

    if (rawValue === null || rawValue === "" || rawValue === "undefined" || rawValue === "null") {
        return fallback;
    }

    try {
        return JSON.parse(rawValue);
    } catch (_error) {
        localStorage.removeItem(key);
        return fallback;
    }
}

function normalizeBookingQuery(data = {}) {
    const normalized = { ...data };

    if (normalized.status !== undefined && normalized.status !== null && normalized.status !== "" && normalized.status !== "ALL") {
        normalized.statuses = Array.isArray(normalized.status)
            ? normalized.status
            : [normalized.status];
    }

    delete normalized.status;

    return normalized;
}


export default new Vuex.Store({
    state: {
        user: parseStoredJson('user', null),
        notifications: parseStoredJson('notifications', []),
        unreadMessage: localStorage.getItem('unreadMessage') || 0,
        unreadMessageConversation: localStorage.getItem('unreadMessageConversation') || "",
        conversationClient: null,
        socket: null,
        userCancellationReason:[],
        complaintCategories:[],
        ai_status: {
            snoozed_at: null,
            snooze_interval: 0,
            dispatch_interval: 0,
            ai_stopped: '0'
        },
        selectedLanguage: normalizeLocale(localStorage.getItem('selectedLanguage')),
        selectedSeason: 'night',
        // besoins:JSON.parse(localStorage.getItem('besoins')) || [],
    },
    getters: {
        selectedLanguage(state) {
            return state.selectedLanguage;
        },
        getSelectedSeason(state) {
            return state.selectedSeason;
        },
        getConversationClient(state) {
            return state.conversationClient;
        },
        getUnreadMessage(state) {
            return state.unreadMessage;
        },
        getUnreadMessageConversation(state) {
            return state.unreadMessageConversation;
        },
        getUserCancellationReason(state){
            return state.userCancellationReason;
        },
        getComplaintCategories(state){
            return state.complaintCategories;
        }
    },
    mutations: {
        // SET_BESOIN(state,value){
        //     // state.besoins.push(value);
        //     state.besoins = [...state.besoins, value];
        //     localStorage.setItem('besoins', JSON.stringify(state.besoins));
        // },
        // DELETE_BESOIN(state, value){
        //     var index = state.besoins.findIndex(besoin => besoin == value);
        //     state.besoins.splice(index, 1);
        //     localStorage.setItem('besoins', JSON.stringify(state.besoins));
        // },
        setSeason(state, value) {
            state.selectedSeason = value;
        },
        setSelectedLanguage(state, language) {
            state.selectedLanguage = normalizeLocale(language);
            localStorage.setItem('selectedLanguage', state.selectedLanguage);
        },
        setUserCancellationReason(state, value) {
            state.userCancellationReason = value;
        },
        setComplaintCategories(state, value) {
            state.complaintCategories = value;
        },
        setTwilioClient(state, client) {
            state.conversationClient = client;
        },
        setUnreadMessage(state, unreadMessage) {
            state.unreadMessage = unreadMessage;
            localStorage.setItem("unreadMessage", unreadMessage);
        },
        setUnreadMessageConversation(state, unreadMessageConversation) {
            state.unreadMessageConversation = unreadMessageConversation;
            localStorage.setItem(
                "unreadMessageConversation",
                unreadMessageConversation
            );
        },
        SET_ONLINE(state, value) {
            state.user = Object.assign({}, state.user, { online: value })
        },
        SET_AI_STATUS(state, status) {
            state.ai_status = status;
        },
        USER_NAME(state, USER_NAME) {
            state.USER_NAME = USER_NAME;
        },
        LOGIN(state, user) {
            // Normalize permissions to UNIQUE name strings, flattening role perms.
            // /login returns user.permissions as flat name strings, but /check_auth
            // returns user.permissions EMPTY with the real permissions nested under
            // user.roles[].permissions (as {id,name,...} objects). validateToken
            // merges check_auth over the login user, so without flattening here the
            // permissions become [] after token re-validation and every menu route
            // is denied (navigation blocked).
            if (user) {
                let perms = Array.isArray(user.permissions) ? user.permissions.slice() : [];
                if (Array.isArray(user.roles)) {
                    user.roles.forEach((r) => {
                        if (r && Array.isArray(r.permissions)) perms = perms.concat(r.permissions);
                    });
                }
                user.permissions = Array.from(
                    new Set(perms.map((p) => (p && typeof p === "object" ? p.name : p)))
                );
            }
            state.user = user;
            setMomentTime(user.timestamp);
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
            localStorage.setItem('user', JSON.stringify(user));
        },
        LOGOUT(state) {
            try {
                axios.defaults.headers.common['Authorization'] = ``;
                state.user = null;
                localStorage.removeItem('user');
                localStorage.removeItem('notifications');
                if (state.socket) state.socket.disconnect();
            } catch (e) {
                console.log(e);
            }
        },
        NEW_NOTIFICATION(state, notification) {
            console.log("NEW_NOTIFICATION");
            state.notifications = [...state.notifications, notification];
            localStorage.setItem('notifications', JSON.stringify(state.notifications));
        },
        INIT_SOCKET(state) {
            state.socket = io(api.SOCKET.USERS, {
                transportOptions: {
                    polling: {
                        extraHeaders: axios.defaults.headers.common
                    }
                }
            });
            // state.socket.on('error', (err) => console.log('SOCKET ERROR', err));

            //TODO: disable receive notifications for specific roles, it must be as permission

           

            state.socket.on('connect', () => {
                console.log("connected");
            })

            // Final-version doc 2026-10-05: stamp with moment.now(), the
            // server-synced clock (util setMomentTime), not the PC clock, so
            // "x minutes ago" is right on a PC whose clock is wrong.
            state.socket.on(api.SOCKET.EVENTS.NEW_NOTIFICATION, ({ message, datetime = moment.now(), color = 'orange' }) => this.commit('NEW_NOTIFICATION', {
                message,
                color,
                datetime
            }));
            state.socket.on('Ai:status_updated', ai_status => this.commit('SET_AI_STATUS', ai_status));
            state.socket.on('Dashboard:new_passenger', (passenger) => {
                const withDocs = !!(passenger.id_card_front || passenger.id_card_back);
                this.commit("NEW_NOTIFICATION", {
                    color: "grey",
                    message: `New Passenger ${passenger.first_name} ${passenger.last_name} ${withDocs ? "With Docs" : "Without Docs"}`,
                    datetime: moment.now()
                });
                // (new Audio(new_passenger_registered)).play();
            });
        }
    },
    actions: {
        setLanguagePreference({ commit, state }, language) {
            commit('setSelectedLanguage', language);
            // Apply direction (dir attribute + Vuetify RTL flag) live on switch.
            applyLocaleSettings(state.selectedLanguage, Vue.prototype.$vuetify);
        },
        async validateToken({ commit, state }, token = null) {
            try {
                let baseUser;
                if (!token) {
                    baseUser = state.user;
                    token = baseUser.accessToken;
                } else {
                    baseUser = {
                        accessToken: token
                    }
                }

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const { data: { data: user } } = await axios.get(api.ACTIONS.CHECK_TOKEN);
                await commit('LOGIN', Object.assign({}, baseUser, user));
                await commit('SET_AI_STATUS', user.ai_status);
            } catch (e) {
                commit('LOGOUT');
            }
        },

        async initSocket({ commit, state }) {
            if (state.socket) state.socket.disconnect();
            commit('INIT_SOCKET');
        },
        async initTwilioConnection({ commit, state }) {
            if (state.user.accessToken) {
                await axios.get(api.ACTIONS.TWILIO_TOKEN)
                    .then(async ({ data }) => {
                        let client = await new Client(data.data);
                        client.conversations = {};
                        commit('setTwilioClient', client);
                        client.on('connectionStateChanged', async (status) => {
                            if (status === 'disconnected') {
                                console.log("Twilio disconnected.");
                            }
                            if (status === 'connected') {
                                if (!firebase.apps.length) {
                                    await firebase.initializeApp({
                                        apiKey: "AIzaSyDLXopouJSP0rFRuX9BMhxWiEHkmWhCX_s",
                                        authDomain: "monaco-taxi-chauffeur.firebaseapp.com",
                                        projectId: "monaco-taxi-chauffeur",
                                        storageBucket: "monaco-taxi-chauffeur.appspot.com",
                                        messagingSenderId: "24902159594",
                                        appId: "1:24902159594:web:a04599ecf8d00276159b93",
                                        measurementId: "G-ZTEKXRQJXB"
                                    });
                                }

                                if (firebase && firebase.messaging()) {
                                    // requesting permission to use push notifications
                                    firebase.messaging().requestPermission().then(() => {
                                        // getting FCM token
                                        firebase.messaging().getToken().then((fcmToken) => {
                                            // passing FCM token to the `conversationClientInstance` to register for push notifications
                                            client.setPushRegistrationId('fcm', fcmToken);
                                            // registering event listener on new message from firebase to pass it to the Conversations SDK for parsing
                                            firebase.messaging().onMessage((payload) => {
                                                const notificationTitle = payload.data.conversation_title;
                                                const notificationOptions = {
                                                    body: payload.data.twi_body,
                                                    icon: '/apple-icon.png'
                                                };
                                                let notification = new Notification(notificationTitle, notificationOptions);
                                                notification.onclick = (event) => {
                                                    window.open(event.target.origin + `/messages?conversation=${event.notification.data.conversation_sid}`);
                                                    notification.close();
                                                }
                                            });

                                        }).catch((err) => {
                                            console.log('Error', err)
                                        });
                                    }).catch((err) => {
                                        // can't request permission or permission hasn't been granted to the web app by the user
                                        console.log('Error', err)
                                    });
                                } else {
                                    // no Firebase library imported or Firebase library wasn't correctly initialized
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }
        },
        getOrders(_context, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(api.ACTIONS.BOOKINGS, { params: normalizeBookingQuery(data) })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((error) => {
                        if (error.message == "Network Error" && !error.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(error.response.data.message);
                        }
                    });
            });
        },
        setUnreadMessagePreference(_context, unreadMessage) {
            localStorage.setItem("unreadMessage", unreadMessage);
            _context.commit("setUnreadMessage", unreadMessage);
        },
        setUnreadMessageConversationPreference(_context, unreadMessageConversation) {
            localStorage.setItem(
                "unreadMessageConversation",
                unreadMessageConversation
            );
            _context.commit("setUnreadMessageConversation", unreadMessageConversation);
        },
        getOrdersPageData(_context, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(api.ACTIONS.BOOKINGS, {
                        params: normalizeBookingQuery(data),
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((error) => {
                        if (error.message == "Network Error" && !error.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(error.response.data.message);
                        }
                    });
            });
        },
        advancedSearch(_context, data) {
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.ADVANCED_SEARCH, {
                    params: data
                })
                    .then(response => {
                        resolve(response.data.data)
                    })
                    .catch(error => {
                        if (error.message == "Network Error" && !error.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(error.response.data.message);
                        }
                    })
            })
        },
        getSeason({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.SETTINGS, {
                    params: {
                        key: 'SEASON'
                    }
                })
                    .then(res => {
                        commit('setSeason', res.data.data['SEASON'] || '');
                        resolve(res.data.data['SEASON']);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(err.response.data.message);
                        }
                    })
            })
        },
        getUserCancellationReasons({ commit, state }) {
            if (state.userCancellationReason.length>0) {
                return state.userCancellationReason;
              }
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.USER_CANCELLATION_REASONS, {
                    params: {
                        only_visible_to_user: true,
                        perPage: 100,
                        page: 1
                    }
                })
                    .then(res => {
                        // Handle paginated response
                        const responseData = res.data.data;
                        const data = (responseData && responseData.data) || responseData || [];
                        commit('setUserCancellationReason', data);
                        resolve(data);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(err.response && err.response.data && err.response.data.message || err.message);
                        }
                    })
            })
        },
        fetchComplaintCategories({ commit, state }) {
            if (state.complaintCategories.length>0) {
                return state.complaintCategories;
              }
            return new Promise((resolve, reject) => {
                axios.get("complaint-category")
                    .then(res => {
                        commit('setComplaintCategories', res.data.data || []);
                        resolve(res.data.data);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(err.response.data.message);
                        }
                    })
            })
        }
    }
});

